import React from "react";
import { Col, Row, Form, Input } from "antd";

const { Item } = Form;

const JobTitle = () => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Job Title</h4>
      </Col>
      <Col xs={24} md={20}>
        <Item name="jobTitle">
          <Input
            size="large"
            name="jobTitle"
            style={{ borderRadius: 8 }}
            placeholder="Your Job Title"
          />
        </Item>
      </Col>
    </Row>
  );
};

export default JobTitle;
